import { useEffect, useRef } from 'react';

// Les filtres restent exploites par les ecrans existants. Cet appel repasse par
// l'endpoint metier afin que le serveur puisse historiser chaque nouvel etat.
const usePartnerFilterConsultation = (filters, request) => {
  const firstRender = useRef(true);
  const requestRef = useRef(request);
  requestRef.current = request;
  const serializedFilters = JSON.stringify(filters || {});

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    const currentFilters = JSON.parse(serializedFilters);
    Promise.resolve(requestRef.current(currentFilters)).catch(() => null);
  }, [serializedFilters]);
};

export default usePartnerFilterConsultation;
